// Per-page SEO tags for the SPA. public/index.html carries the site-wide
// defaults; pages call setPageSeo() once their data is loaded so the title,
// description, canonical and og:* tags describe the page that is on screen.
export const SITE_URL = 'https://restaurants.ez11.com';
export const SITE_NAME = 'ez restaurants';

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

// Upserts <title>, meta description, link[rel=canonical], og:url/og:title/og:description.
// canonicalPath: '/portal/r/kikis' (no query string). Missing fields are left as they are.
export function setPageSeo({ title, description, canonicalPath } = {}) {
  if (typeof document === 'undefined') return;
  if (title) {
    document.title = title;
    upsertMeta('property', 'og:title', title);
  }
  if (description) {
    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:description', description);
  }
  if (canonicalPath) {
    const url = `${SITE_URL}${canonicalPath}`;
    upsertCanonical(url);
    upsertMeta('property', 'og:url', url);
  }
}
